/* Card savings re-sync (2026-08-21). snippets/price.liquid renders the red SAVE pill from Liquid. Intelligems price tests rewrite the rendered price text client-side,
   so this re-derives it from the DISPLAYED compare-at / price whenever they differ from the
   Liquid values (data-price-cents / data-compare-cents), and hides the treatment when the
   displayed compare-at is not higher than the displayed price. Larger-number rule matches
   Liquid: SAVE $N when whole-dollar savings >= percent, else SAVE N%. */
(function () {
  function parseMoney(text) {
    if (!text) return null;
    var t = text.replace(/[^\d.,]/g, '');
    if (!t) return null;
    var lastComma = t.lastIndexOf(','), lastDot = t.lastIndexOf('.');
    if (lastComma > lastDot) { t = t.replace(/\./g, '').replace(',', '.'); }   /* 1.234,56 */
    else { t = t.replace(/,/g, ''); }                                          /* 1,234.56 */
    var n = parseFloat(t);
    return isNaN(n) ? null : n;
  }
  function symbolOf(text) {
    var m = (text || '').match(/^\s*([^\d\s]+)/);
    return m ? m[1] : '$';
  }
  function sync(price) {
    if (price.getAttribute('data-savings-card') !== 'true') return;
    var cmpEl = price.querySelector('.price-item--sale');
    var curEl = price.querySelector('.price-item--regular.on--sale');
    var pill = price.querySelector('[data-save-pill]');
    if (!cmpEl || !curEl || !pill) return;
    var cmp = parseMoney(cmpEl.textContent), cur = parseMoney(curEl.textContent);
    if (cmp === null || cur === null) return;
    var liquidCmp = parseInt(price.getAttribute('data-compare-cents') || '0', 10) / 100;
    var liquidCur = parseInt(price.getAttribute('data-price-cents') || '0', 10) / 100;
    var changed = Math.abs(cmp - liquidCmp) > 0.005 || Math.abs(cur - liquidCur) > 0.005;
    if (!changed && price.__savingsSynced) return;
    price.__savingsSynced = true;
    if (cmp <= cur) { pill.hidden = true; return; }
    var diff = cmp - cur;
    var pctOff = Math.floor(diff * 100 / cmp);
    var units = Math.round(diff);
    pill.hidden = false;
    var label = pill.querySelector('.sale-percentage') || pill;
    label.textContent = units > pctOff ? 'SAVE ' + symbolOf(cmpEl.textContent) + units : 'SAVE ' + pctOff + '%';
  }
  function syncAll() {
    document.querySelectorAll('.price.price--on-sale[data-savings-card="true"]').forEach(sync);
  }
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(syncAll, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll); else syncAll();
  /* Intelligems / AJAX grids (facets, predictive search, third-party grids) replace or edit price nodes */
  new MutationObserver(schedule).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
})();
